// extracted by mini-css-extract-plugin
module.exports = {"sections":"Mobile_sections__6iBAe","group":"Mobile_group__T7sIx"};